import { useEffect, useState } from 'react';

import { FEATURE_FLAGS } from '../common/context/FlagsContext';
import { useFeatureFlagsValue } from '../common/context/FlagsValueContext';

/**
 * Hook to check if Grafana Faro observability is enabled via feature flag.
 */
export function useFaroEnabled() {
  const [faroEnabled, setFaroEnabled] = useState<boolean | undefined>(undefined);
  const flagsContext = useFeatureFlagsValue();

  useEffect(() => {
    /**
     * true if feature flag is enabled
     * false if feature flag is disabled
     * undefined if feature flag query is pending
     */
    const { flags, areFlagsLoaded } = flagsContext;
    if (!areFlagsLoaded) {
      setFaroEnabled(undefined);
      return;
    }

    const enabled = flags?.find(v => v?.flagKey === FEATURE_FLAGS.ENABLE_GRAFANA_FARO?.toString())?.flagValue === true;

    let enabledVal = enabled;
    if (enabledVal !== true) {
      const localOverride = process.env.REACT_APP_ENABLE_GRAFANA_FARO_OVERRIDE;
      if (localOverride === 'true') {
        enabledVal = true;
      }
    }
    setFaroEnabled(enabledVal ?? false);
  }, [flagsContext]);

  return { faroEnabled };
}
